var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./SlideMediaItem.scss";
var SlideMediaItem = function (_a) {
    var slide = _a.slide, _b = _a.isActive, isActive = _b === void 0 ? false : _b, onSingleClickMedia = _a.onSingleClickMedia, refProp = _a.refProp;
    return (_jsx("div", __assign({ className: "slide-item ".concat(isActive ? "active" : ""), onClick: function () { return onSingleClickMedia && onSingleClickMedia(slide.time); }, ref: refProp }, { children: _jsx("img", { src: slide.url, alt: "" }) })));
};
export default SlideMediaItem;
